<template>
  <div class="template-book-refund">
    <TheHeader
      :headerTitle="$t('TicketStoreTicketing.bookBookingConfirmationTitle')"
    />
    <header />

    <section class="section-top refund-conf">
      <!-- 枕詞 -->
      <div class="message">
        チケット内容を確認してください。<br />
        「払いもどす」ボタンを押すと決済画面に進みます。
      </div>
      <!-- 枕詞 -->

      <!-- チケット名 -->
      <MbTicketNameDisp :name="displayBookName(bookGroup, masterBook)" />
      <!-- チケット名 -->

      <hr />

      <!-- 購入内容-->
      <TheTicketPurchaseDetailsOfRefund />

      <!-- 注意・ボタン -->
      <TheBookRefundFooter />
      <!-- ボタン -->
    </section>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateBookRefund",
  components: {},

  setup() {
    const store = useStore();

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    return {
      bookGroup,
      masterBook,
    };
  },
};
</script>

<style lang="scss" scoped>
.message {
  margin: 10px 0 20px 0;
  font-size: 11px;
  line-height: 17px;
}
.template-book-refund {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
